import { render, staticRenderFns } from "./Cursos-talleres.vue?vue&type=template&id=5dc76b10&scoped=true"
import script from "./Cursos-talleres.vue?vue&type=script&lang=js"
export * from "./Cursos-talleres.vue?vue&type=script&lang=js"
import style0 from "./Cursos-talleres.vue?vue&type=style&index=0&id=5dc76b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc76b10",
  null
  
)

export default component.exports